import { axiosApi } from "../lib/axios";
import { apiUrl } from "../environment";
import { toast } from "react-toastify";
import { toast_error, toast_success } from "../config/Constant";
import { decryptData } from "../utils/encryptDecrypt";

let axiosConfigFormData = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const API_URL = apiUrl;
//login
export const login = async (payload) => {
  try {
    const response = await axiosApi.post(API_URL + "/api/user/login", payload);
    if (response.data.status) {
      localStorage.setItem("users", JSON.stringify(response.data));

      return response;
    } else {
      return response;
    }
  } catch (e) {
    return e;
  }
};
export const masterLogin = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/user/masterLogin",
      payload
    );
    if (response.data.status) {
      localStorage.setItem("users", JSON.stringify(response.data));

      return response;
    } else {
      return response;
    }
  } catch (e) {
    return e;
  }
};

export const logOut = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/logout", payload);
  } catch (e) {
    return e;
  }
};

export const refresh = async (refreshToken) => {
  try {
    const response = await axiosApi.post(API_URL + "/api/auth/refresh", {
      refreshToken,
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const usersignup = async (fromdata) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/signup", fromdata);
  } catch (e) {
    return e;
  }
};

export const sendOtp = async (email) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/sendOtp", email);
  } catch (e) {
    return e;
  }
};

export const sendOtpSignUp = async (email) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/sendOtpSignUp", email);
  } catch (e) {
    return e;
  }
};

export const verfiyemail = async (input) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/verifyEmail", {
      email: input.email,
      otp: input.otp,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkgooglemail = async (chekdata) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/checkEmailGoogle", {
      email: chekdata.email,
      social_id: chekdata.social_id,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const googleLoginApi = async (access_token) => {
  const result = await axiosApi.get(
    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${access_token}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );
  return result;
};

export const resendOtp = async (input) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/resendOtp", input);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkForgotOtp = async (input) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/checkForgotOtp", input);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const forgotPassword = async (input) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/forgotPassword", input);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const resetPassword = async (input) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/resetPassword", input);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const deleteProfileById = async (paylaod) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/deleteProfileById",
      paylaod
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const orderTransaction = async ({ user_id, product_id, total }) => {
  try {
    return await axiosApi.post("commerce/transactions", {
      user_id,
      product_id,
      total,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const orderHistroy = async (user_id) => {
  try {
    return await axiosApi.post("commerce/oaderDetails", { user_id });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const getService = async () => {
  return axiosApi.get("/api/provider/getServiceList");
};

export const dashboardProjectsData = async (
  startDate,
  endDate,
  timePeriod,
  selectedOption
) => {
  return await axiosApi.post(`/api/provider/dashboardCountsData`, {
    startDate: startDate,
    endDate: endDate,
    timePeriod: timePeriod,
    serviceId: selectedOption,
  });
};

export const joSummeryData = async () => {
  return await axiosApi.post(``);
};

export const dashboardCountData = async (graphDate, graphType) => {
  return await axiosApi.post("/api/provider/dashboardProjectsData", {
    graphDate: graphDate,
    graphType: graphType,
  });
};

export const serviceList = async (keyword, isParent) => {
  return await axiosApi.post("/api/user/serviceSearch", {
    keyword: keyword,
    isParent: isParent,
  });
};

export const childrenServiceList = async (payload) => {
  return await axiosApi.post("/api/user/getChildrenServices", payload);
};

export const filterProvider = async (payload) => {
  const response = await axiosApi.post(
    "/api/user/findProviderByServiceId",
    payload
  );
  const decrypt = await decryptData(response.data.providerData);

  response.data.providerData = decrypt;

  return response;
};

export const getCategoriesList = async (payload) => {
  return await axiosApi.post("/api/user/serviceSearch", payload);
};

export const serviceFilter = async (payload) => {
  return await axiosApi.post("/api/user/serviceFilter", payload);
};

export const recommendedProvider = async (payload) => {
  const response = await axiosApi.post(
    "/api/user/recommendedProviders",
    payload
  );

  const decrypt = decryptData(response.data.providerData);
  response.data.providerData = decrypt;
  return response;
};

export const checkEmail = async (accessToken) => {
  const response = await axiosApi.post(`/api/user/checkEmail`, {
    accessToken,
  });
  return response;
};

export const checkEmailGoogle = async (access_token) => {
  const response = await axiosApi.post(API_URL + `/api/user/checkEmailGoogle`, {
    access_token,
  });
  return response;
};

export const fbLogin = async (payload) => {
  const response = await axiosApi.post(`/api/user/fbLogin`, payload);
  return response;
};

export const GoogleLoginCheck = async (payload) => {
  const response = await axiosApi.post(`/api/user/googleLogin`, payload);
  return response;
};

export const ChangePassword = async (payload) => {
  try {
    const response = await axiosApi.post(
      `/api/provider/changePassword`,
      payload
    );
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

//****************provider api***************************************************************************

export const provider_getProfile = async (callback) => {
  try {
    const response = await axiosApi.get(`${API_URL}/api/provider/getProfile`);
    const { provider, bankDetails } = response.data;

    // Decrypt provider data
    if (provider) {
      response.data.provider = decryptData(provider);
    }

    // Decrypt bank details as a whole
    if (bankDetails && typeof bankDetails === "string") {
      response.data.bankDetails = decryptData(bankDetails);
    }

    return response;
  } catch (e) {
    toast.error(
      e.response?.data?.message || "Failed to fetch profile",
      toast_error
    );
    return e;
  }
};

export const findUserById = async (payload) => {
  try {
    let response = await axiosApi.post(API_URL + "/api/user/findById", payload);

    let decrypt = decryptData(response.data);
    response.data = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const updateAvailability = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateAvailability",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const updateProfile = async (providerData) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateProfile",
      providerData
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
  }
};

export const fetchJobs = async (payload) => {
  try {
    let response = await axiosApi.post(
      API_URL + "/api/provider/myJobsList",
      payload
    );

    let decrypt = await decryptData(response.data.jobs);
    response.data.jobs = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchUserJobs = async (payload) => {
  try {
    let response = await axiosApi.post(
      API_URL + "/api/user/myJobsList",
      payload
    );
    let decrypt = decryptData(response.data.jobs);
    response.data.jobs = decrypt;
    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchAllJobs = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/provider/allJobsList", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchIncomingJobs = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/jobRequestList",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserIncomingJobs = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/jobRequestList", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const approveRejectJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/changeJobStatus",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const approveRejectQuote = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/updateQuoteStatus", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const cancelUserJob = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/cancelJob", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchJobDetails = async (payload) => {
  try {
    let responce = await axiosApi.post(
      API_URL + "/api/provider/findJobById",
      payload
    );

    let decrypt = decryptData(responce.data.jobData);
    responce.data.jobData = decrypt;
    return responce;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchUserJobListByReqType = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/jobsList", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const calculateTax = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/calculateTaxAmount",
      payload
    );
  } catch (e) {
    // toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const calculateTaxByAmount = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/calculateTaxByAmount",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const markJobComplete = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/update", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkProviderStartJob = async (jobId) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/job/checkProviderStartJob",
      { jobId }
    );
    return response.data;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Handle error appropriately
  }
};

export const createDispute = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/admin-user/createDispute",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    return e;
  }
};

export const shareReQuote = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/quoteFileUpload",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    return e;
  }
};

export const updateDeliveryStatus = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateTrackingStatus",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const verifyJobOtp = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/matchOtp", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const markCompleteJob = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/markCompleteJob", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateProviderStartJob = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/updateProviderStartJob",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Handle error appropriately
  }
};

export const getJobQuoteStatusById = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/job/getJobQuoteStatusById",
      payload
    );
    return response.data; // Ensure you return the data property
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return null; // Return null or handle it as per your requirements
  }
};

export const uploadSelfie = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/uploadSelfie",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    return e;
  }
};

export const createJobReview = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/saveRating", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getProviderListByServiceId = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/user/findProviderByServiceId",
      payload
    );

    const decrypt = await decryptData(response.data.providerData);

    response.data.providerData = decrypt;

    return response;
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchProviderServiceList = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/getProviderServicesList",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderRatingDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/user/getProviderRatingDetail",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderServiceDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/service/findByProvider",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderRating = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/getRatingsList",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserRating = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/getRatingsList", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchProviderAvailability = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/providerAvailability",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const createJob = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/create", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const uploadVoceNote = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/job/upload-voice-note", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchSavedAddress = async (payload) => {
  try {
    return await axiosApi.get(
      API_URL + `/api/user/findSavedAddress?type=${payload}`
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const findNonTruckingSavedAddress = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/user/findNonTruckingSavedAddress`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchSubscriptionPlans = async () => {
  try {
    return await axiosApi.get(API_URL + `/api/provider/getPlanList`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const applyPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/purchaseSubscription`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/checkPromoCode`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchTransactionDetails = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/transaction/findAllTransaction`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const giveTip = async (payload) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/giveTip", payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getAllContent = async () => {
  try {
    return await axiosApi.get(API_URL + "/api/admin-user/getAllContent");
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getContent = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/admin-user/getContentById",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};
export const fetchNotification = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/notification/listWithPagination`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchLiveLocation = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/user/getLiveLocation`, payload);
  } catch (e) {
    return e;
  }
};

export const updateProfile_customer = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/user/updateProfile`, payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateNotificationSettings = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateNotificationSettings`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const deleteService = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/admin-provider/deleteService`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateAvailabilityTiming = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/updateShiftTiming`, {
      shifts: payload,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateNotificationSettingsProvider = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateNotificationSettings`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateJobBufferSettings = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateJobBufferSettings`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const sendReferralEmail = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/sendReferralEmail`, payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const saveGoogleAccessToken = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/saveGoogleToken`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};


export const fetchProviderRevenueData = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/transactionCountsData`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchUserRevenueData = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/user/userTransactionCountsData`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceSummery = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/serviceSummery`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const completedServicesSummery = async () => {
  try {
    return await axiosApi.post(API_URL + `/api/provider/completedServicesById`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const roleSwich = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/user/switchUserType`, payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

//Api call for fetching customer authorize profile
export const fetchAuthorizeCustomerProfile = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/getCustomerProfile",
      payload
    );
  } catch (error) {
    // Error handled silently
  }
};

//Api call for  add card authorize profile
export const addCard = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/createCustomerPaymentProfile",
      payload
    );
  } catch (error) {
    // Error handled silently
  }
};

//Api call for  delete card authorize profile
export const deleteCard = async (payload) => {
  try {
    return await axiosApi.post(
      "/api/paymentGateway/deleteCustomerPaymentProfile",
      payload
    );
  } catch (error) {
    // Error handled silently
  }
};

//Api call for  delete card authorize profile
export const fetchTipPlatformFee = async (payload) => {
  try {
    return await axiosApi.get("/api/user/getTipPlatformFee");
  } catch (error) {
    // Error handled silently
  }
};

//Api call for  send job payment
export const sendJobPayment = async (payload) => {
  try {
    return await axiosApi.post("/api/paymentGateway/sendJobPayment", payload);
  } catch (error) {
    return error;
  }
};

//Api call for  get bank status
export const fetchBankDetailsStatus = async () => {
  try {
    return await axiosApi.get("/api/provider/getBankDetails");
  } catch (error) {
    // Error handled silently
  }
};

//Api call for generating job invoice
export const fetchProviderJobInvoice = async (payload) => {
  try {
    return await axiosApi.post("/api/job/generateJobInvoice", payload);
  } catch (error) {
    // Error handled silently
  }
};

export const setPrimaryPaymentProfile = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/paymentGateway/setPrimaryPaymentProfile`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const addAccountDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/addBankDetail`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateAccountDetail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/updateBankDetail`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkDoucument = async (payload) => {
  try {
    return await axiosApi.post(API_URL + `/api/user/checkDocument`, payload);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const changeJobStartTime = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/changeJobTime`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceImageUpload = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/serviceImageUpload`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const serviceImageRemove = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/serviceImageRemove`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const fetchMarketingSubsPlans = async () => {
  try {
    return await axiosApi.get(API_URL + `/api/provider/getMarketingPlanList`);
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const checkMarketingPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/checkMarketingPlanPromoCode`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const applyMarketingPromoCode = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + `/api/provider/purchaseMarketingSubscription`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const sendMarketingJobEmail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/sendMarketingJobEmail",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

// Create booking request
export const createBookingRequest = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/booking-request/create",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message || "Failed to create booking request", toast_error);
    return e;
  }
};

export const getServiceListForUser = async () => {
  return axiosApi.get("/api/provider/getServiceListForUser");
};

export const UpdateMarketingEmail = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/provider/updateMarketingEmail",
      payload
    );
  } catch (e) {
    return e;
  }
};

export const shareFinalQuote = async (fromdata) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/finalQuoteFileUpload",
      fromdata,
      axiosConfigFormData
    );
  } catch (e) {
    return e;
  }
};

export const fetchJobsCount = async (payload) => {
  try {
    return await axiosApi.get(API_URL + "/api/provider/jobRequestCount");
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const giveSuggestion = async (description, email) => {
  try {
    return await axiosApi.post(API_URL + "/api/user/reportBug", {
      description: description,
      email: email,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const getJobMarksByUserId = async (userId) => {
  try {
    return await axiosApi.post(API_URL + `/api/job/userJobMarksCount`, {
      userId: userId,
    });
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const updateJobStatusByUser = async (payload) => {
  try {
    return await axiosApi.put(
      API_URL + `/api/job/updateJobStatusByUser`,
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

export const verifyCoupons = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + `/api/coupon/verifyCoupons`,
      payload
    );

    toast.success(
      response?.data?.message || "Coupon verified successfully!",
      toast_success
    );
    return response;
  } catch (e) {
    toast.error(
      e.response?.data?.message || "Something went wrong!",
      toast_error
    );
    return e;
  }
};

// Create job from accept offer
export const createJobFromOffer = async (payload) => {
  try {
    return await axiosApi.post(
      API_URL + "/api/job/create-from-offer",
      payload
    );
  } catch (e) {
    toast.error(e.response?.data?.message, toast_error);
    return e;
  }
};

// Create broker request
export const createBrokerRequest = async (payload) => {
  try {
    const response = await axiosApi.post(
      API_URL + "/api/broker",
      payload
    );
    return response;
  } catch (e) {
    toast.error(
      e.response?.data?.message || "Failed to submit request",
      toast_error
    );
    return e;
  }
};

// Send OTP for broker signup
export const sendBrokerOtp = async (email) => {
  try {
    return await axiosApi.post(API_URL + "/api/broker/send-otp", { email });
  } catch (e) {
    toast.error(e.response?.data?.message || "Failed to send OTP", toast_error);
    return e;
  }
};

// Verify OTP for broker signup
export const verifyBrokerOtp = async (email, otp) => {
  try {
    return await axiosApi.post(API_URL + "/api/broker/verify-otp", { email, otp });
  } catch (e) {
    toast.error(e.response?.data?.message || "Failed to verify OTP", toast_error);
    return e;
  }
};